// VehTypeInfoDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

export const RentTypes = {
    no_rent: '용차 아님',
    rent1: '용차-1',
    rent2: '용차-2',
};

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    custId : {toAdd: true, toEdit: true},
    
    vehTypeId : {
        id: 'vehTypeId', required: true, toAdd: false, toEdit: true,
    },
    vehTypeName : {
        id: 'vehTypeName', label: '차종', type: InputType.text, required: true,
        toAdd: true, toEdit: true,
        help: '16자 이내로 입력하세요.',
        check: (value) => {return IsValid.string(value, 1, 30)},
    },
    freshCargo : {
        id: 'freshCargo', label: '신선차량', type: InputType.checkbox, required: false,
        toAdd: true, toEdit: true,
    },
    cargoUnit : {
        id: 'cargoUnit', label: '적재단위', type: InputType.text, required: false,
        toAdd: true, toEdit: true,
        help: '30자 이내로 입력하세요.',
        check: (value) => {return IsValid.string(value,0,30)},
    },
    loadCapa : {
        id: 'loadCapa', label: '적재용량', type: InputType.number, required: false,
        toAdd: true, toEdit: true,
        check: (value) => {return value > 0 && value < 99999},
    },
    loadCapaText : {
        id: 'loadCapaText', label: '적재용량설명', type: InputType.text, required: false,
        toAdd: true, toEdit: true,
        help: '10자 이내로 입력하세요.',
        check: (value) => {return IsValid.string(value, 0, 30)},
    },
    minLoad : {
        id: 'minLoad', label: '최소적재용량', type: InputType.number, required: false,
        toAdd: true, toEdit: true,
        check: (value) => {return value >= 0 && value < 99999},
    },
    minTemp : {
        id: 'minTemp', label: '최저온도', type: InputType.number, required: false,
        toAdd: true, toEdit: true,
        check: (value) => {return value >= -999 && value <= 999},
    },
    maxTemp : {
        id: 'maxTemp', label: '최고온도', type: InputType.number, required: false,
        toAdd: true, toEdit: true,
        check: (value) => {return value >= -999 && value <= 999},
    },
    rentType : {
        id: 'rentType', label: '용차구분', type: InputType.select, required: false,
        toAdd: true, toEdit: true,
        selectList: Object.keys(RentTypes).map((key)=>{return {rentType:key, label:RentTypes[key]}}),
    },
    fontColor : {
        id: 'fontColor', label: '지도차량전경색', type: InputType.color, required: false,
        toAdd: true, toEdit: true,
        default: '#FFFFFF',
    },
    backColor : {
        id: 'backColor', label: '지도차량배경색', type: InputType.color, required: false,
        toAdd: true, toEdit: true,
        default: '#000000',
    },
};


function printColor(r,i,v) {
    return <span style={{color:v,backgroundColor:r.backColor,display:'inline-block', borderRadius:5}}>차량번호</span>;
}

export const VehTypeInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '차종정보 생성 오류',
        Edit: '차종정보 수정 오류',
        Remove: '차종정보 삭제 오류',
        Get: '차종정보 조회 오류',
    },
    tableProps: {
        tableId: 'vehTypeInfoTable',
        uniqueKey: 'vehTypeId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            //{ id: 'vehTypeId', label: Dict.vehTypeId.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'freshCargo', label: Dict.freshCargo.label, width: 90, show: true, option:{align: 'center', print:(r,i,v)=>v?'신선':''} },
            { id: 'cargoUnit', label: Dict.cargoUnit.label, width: 90, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'loadCapa', label: Dict.loadCapa.label, width: 80, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
            { id: 'loadCapaText', label: Dict.loadCapaText.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'minLoad', label: Dict.minLoad.label, width: 100, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
            { id: 'minTemp', label: Dict.minTemp.label, width: 90, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
            { id: 'maxTemp', label: Dict.maxTemp.label, width: 90, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
            { id: 'rentType', label: Dict.rentType.label, width: 100, show: true, option:{align: 'inherit', print: (r,i,v)=>RentTypes[v]} },
            //{ id: 'fontColor', label: '지도상 색깔', width: 120, show: true, option:{align: 'inherit', print: printColor} },
            // { id: 'backColor', label: Dict.backColor.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'regUser', label: '등록자', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
            { id: 'regDate', label: '등록일', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATETIME} }
        ]
    },
};
